import { Component } from 'react';

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { colors, getRandomColor } from '../../../lib/colors';
import { getPercentForChart, tableColumns } from './keys';
import CheckData from '../../../components/CatchError';
import DataTable from '../../../components/Datatable';
import { Pie } from 'react-chartjs-2';
import numeral from 'numeral';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend);

class PositionModule2 extends Component {
    constructor() {
        super();
    }

    searchFunction(data) {
        return data;
    }

    render() {
        const { t } = this.props;

        const options = {
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        label: (context) => {
                            const percent = `${getPercentForChart(
                                context.dataset.data,
                                context.parsed,
                            ).toFixed(2)}%`;
                            return `Position - ${context.label} : ${numeral(context.parsed).format(
                                '0.0a',
                            )} Keyword${context.parsed > 1 ? 's' : ''} (${percent})`;
                        },
                    },
                },
            },
        };

        const pieData = {
            labels: this.props.data?.map((item) => item.position),
            datasets: [
                {
                    label: 'Keywords',
                    data: this.props.data?.map((x) => x.keywords),
                    backgroundColor: this.props.data?.map(
                        (item, i) => colors[i] ?? getRandomColor(),
                    ),
                },
            ],
        };

        return (
            <CheckData
                content_id={this.props.content_id}
                parent_id={this.props.parent_id}
                data={this.props.data}
                loading={this.props.loading}
            >
                <div
                    className="Timeline"
                    style={{ height: '100%', minHeight: '150px', position: 'relative' }}
                >
                    {this.props.data?.[0] ? (
                        <div className="row">
                            <div
                                className="col-sm-12 col-md-6"
                                style={{ height: '400px', position: 'relative' }}
                            >
                                <Pie data={pieData} options={options} />
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="row">
                                    <div className="col">
                                        <DataTable
                                            nodes={this.props.data}
                                            sortFns={() => {}}
                                            COLUMNS={tableColumns(t)}
                                            uniqKey={'position'}
                                            fileName={t('search.ctr_per_position.header')}
                                            searchFunction={this.searchFunction}
                                            onlyTable
                                            hasSort={false}
                                            onlyPagination
                                            defaultSize={5}
                                            forceRun={this.props.forceRun}
                                            additionalStyles={{
                                                BaseCell: ` font-family: 'Raleway';
                                                        font-weight: 500;
                                                        font-size: 16px;
                                                        line-height: 19px;
                                                        padding: 16px 10px !important;
                                                        color: #0D182C;
                                                    
                                                        &.underline {
                                                            text-decoration: underline;
                                                        }
                                                        `,
                                                Table: `
                                                    --data-table-library_grid-template-columns : minmax(100px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr) minmax(110px, 1fr) !important;,
                                                   ${scrollForTable}
                                                 `,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>There is no data</div>
                    )}
                </div>
            </CheckData>
        );
    }
}

export default withTranslation()(PositionModule2);
